<div class="welcome-container">
  <div class="header">
    <div class="logo">
      <img src="genesys-com-full-color.svg" width="200px" height="36px" alt="Genesys Logo" class="genesys-logo" />
    </div>
  </div>

  <div class="region-header">
    <div class="region-header-top">
      <div>
        <h2>Select your Genesys Cloud region to sign in.</h2>
        @if (!limitedRegionView) {
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search regions</mat-label>
            <input
              matInput
              [ngModel]="searchQuery()"
              (ngModelChange)="searchQuery.set($event)"
              placeholder="e.g. Sydney, Europe, Americas" />
            @if (searchQuery()) {
              <button matSuffix class="clear-btn" aria-label="Clear" (click)="searchQuery.set('')">
                <mat-icon [svgIcon]="'close'"></mat-icon>
              </button>
            } @else {
              <mat-icon matSuffix aria-hidden>search</mat-icon>
            }
          </mat-form-field>
        }
      </div>
    </div>
  </div>

  @if (groupedRegions().length === 0) {
    <p class="no-results">No regions found for "{{ searchQuery() }}".</p>
  }

  @for (group of groupedRegions(); track group.group) {
    <div class="region-group">
      <h3 class="group-heading">{{ group.group }}</h3>
      <ul>
        @for (region of group.regions; track region.env) {
          <li>
            <mat-card class="brand-neutral-white-card bgc-glass" appearance="outlined" (click)="onRegionClick(region)">
              <mat-card-content>
                <a class="no-underline" (click)="onRegionClick(region)">
                  <h6>{{ region.awsGenericRegion | uppercase }}</h6>
                </a>
                <a class="no-underline" (click)="onRegionClick(region)">
                  <h5>{{ region.label }}</h5>
                </a>
              </mat-card-content>
              <mat-card-actions class="small-actions">
                <a
                  (click)="onRegionClick(region)"
                  class="icon"
                  [matTooltip]="'Sign in with ' + region.label"
                  [matTooltipShowDelay]="1000"
                  [matTooltipHideDelay]="2000">
                  <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                </a>
              </mat-card-actions>
            </mat-card>
          </li>
        }
      </ul>
    </div>
  }
</div>
